<template>
  <div>
    <component
      :is="component"
      v-if="component"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BModal,
  BButton,
  BCardText,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Manager from '@/views/Dashboard/Manager.vue'

export default {
  components: {
    BRow,
    BCol,
    BModal,
    BButton,
    BCardText,
    Manager,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      component: null,
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  created() {
    this.dashboardType()
  },
  methods: {
    dashboardType() {
      if (this.userData.type === 'admin') {
        this.component = 'Manager'
      }
    },
  },
}
</script>

<style>

</style>
